import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Services from "@/components/sections/Services";
import Niches from "@/components/sections/Niches";
import Portfolio from "@/components/sections/Portfolio";
import BeforeAfter from "@/components/sections/BeforeAfter";
import Process from "@/components/sections/Process";
import Testimonials from "@/components/sections/Testimonials";
import CtaBlock from "@/components/sections/CtaBlock";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-[#0A0A0A] text-white overflow-x-hidden">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Niches />
      <Portfolio />
      <BeforeAfter />
      <Process />
      <Testimonials />
      <CtaBlock />
      <Contact />
      <Footer />
    </main>
  );
}
